// extracted by mini-css-extract-plugin
module.exports = {"root":"Oj72I","icon":"_2Tv0x","newLoginSocialBarStyles":"_tNJQ","ltr":"_31yWt","withCount":"_7goxk","rtl":"_3Z5sI","badge":"tOfYI"};